
document.querySelectorAll('.collection_links .col_name').forEach(col => {
  col.addEventListener('click', function() {
    // Remove active class from all collection links
    document.querySelectorAll('.collection_links .col_name').forEach(item => {
      item.classList.remove('active');
    });

    // Add active class to clicked element
    this.classList.add('active');

    // Get clicked link's data-rel
    const current_link = this.getAttribute('data-rel');

    // Loop through products
    document.querySelectorAll('.coll_products_container .coll_product').forEach(product => {
      const active_col = product.getAttribute('data-pro');

      if (current_link === active_col) {
        // Remove active from all products first
        document.querySelectorAll('.coll_products_container .coll_product').forEach(p => {
          p.classList.remove('active');
        });

        // Add active only to the matched one
        product.classList.add('active');
      }
    });
  });
});

function init() {
  setEqualHeights();

  const colorChartFilter = document.querySelector(".color-chart-filters");
  if(colorChartFilter) {
    let header__height = Shopify.theme.jsHeader.getHeaderHeight();
    colorChartFilter.style.top = `${header__height}px`;
  }
}

function setEqualHeights() {
    let maxHeight = 0;
    const items = document.querySelectorAll('.testimonial-block');

    // reset first (important if resizing)
    items.forEach(item => {
      item.style.height = 'auto';
    });

    // find tallest
    items.forEach(item => {
      if (item.offsetHeight > maxHeight) {
        maxHeight = item.offsetHeight;
      }
    });

    // apply tallest height to all
    items.forEach(item => {
      item.style.height = maxHeight + 'px';
    });
  }

  // Run on load + after Flickity settle
  window.addEventListener('load', init);
  window.addEventListener('resize', init);

  
  const filterBtns = document.querySelectorAll(".filter-btn");
  const categories = document.querySelectorAll(".color-category");

  filterBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      let category = btn.getAttribute("data-category");

      // Active state
      filterBtns.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      let target;
      if (category === "all") {
       target = document.querySelector('.color-chart-wrapper');
      } else {
       target = document.querySelector(`[data-category-content=${category}]`);
      }
      
      if (!target) return;

      let offset = target.getBoundingClientRect().top + window.scrollY;
      const headerHeight = Shopify.theme.jsHeader.getHeaderHeight() + document.querySelector(".color-chart-filters").offsetHeight;
      const isHeaderSticky = Shopify.theme.jsHeader.enable_sticky;

      if (isHeaderSticky) {
        offset -= headerHeight;
      }

      // Smooth scroll
      window.scrollTo({
        top: offset,
        behavior: "smooth"
      });

    });
  });

  // FAQ Page

  $('.faq-tab').on('click', function () {
    $('.faq-tab').removeClass('active');
    $('.faq-content').removeClass('active');
    $(this).addClass('active');
    $('#' + $(this).data('tab')).addClass('active');
  });

  $(".faq-question").on('click',function(){
      $(this).closest(".faq__block-faq").siblings(".faq__block-faq").find(".tab--open .faq__item-answer").slideUp();
      $(this).closest(".faq__block-faq").siblings(".faq__block-faq").find(".tab--open").removeClass("tab--open");
      if($(this).siblings('.faq__item-answer').css('display')=='none'){
          $(this).parent().addClass('tab--open')
          $(this).siblings('.faq__item-answer').slideDown()
      }else{
          $(this).siblings('.faq__item-answer').slideUp(()=>{
              $(this).parent().removeClass('tab--open')
          })
      }
  });


  $(document).ready(function(){
    $('.filter__btns__container .filter__button').on('click', function(){
      if($(this).hasClass('active')){
          $(this).removeClass('active');
          $(this).closest('.container').find('.collapse-sidebar-section').removeClass('active');
      }
      else{
          $(this).addClass('active');
          $(this).closest('.container').find('.collapse-sidebar-section').addClass('active');
      }
    })
  })